import React from 'react';

interface PdfAttachmentProps {
  pdfUrl: string;
  onLoadOrError: (error: boolean) => void;
}

const Pdf: React.FC<PdfAttachmentProps> = ({ pdfUrl, onLoadOrError }) => (
  <object
    onLoad={() => {
      onLoadOrError(true);
    }}
    onError={() => {
      onLoadOrError(false);
    }}
    className="task-attachment__item task-attachment__item--embed"
    type="application/pdf"
    data={pdfUrl}
  />
);

export default Pdf;
